import { render } from "./App.vue?vue&type=template&id=44dbc39e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=44dbc39e&lang=css"

import exportComponent from "/home/gitlab-runner/builds/RJKESzs2/0/roolz/poi-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__